import { render, staticRenderFns } from "./HelpVideo.vue?vue&type=template&id=a6a58d28&scoped=true"
import script from "./HelpVideo.vue?vue&type=script&lang=js"
export * from "./HelpVideo.vue?vue&type=script&lang=js"
import style0 from "./HelpVideo.vue?vue&type=style&index=0&id=a6a58d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a58d28",
  null
  
)

export default component.exports